













































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import { CoverageInfo } from "@/API";
import * as CoverageInfoService from "@/services/coverage/coverageInfoService";
import { SearchForm } from "@/services/coverage/coverageInfoService";
import CoverageInfoCreateForm from "./CoverageInfoCreateForm.vue";
import CoverageInfoEditForm from "./CoverageInfoEditForm.vue";
import CoverageInfoView from "./CoverageInfoView.vue";
import { decodeRoleJson, isAllow } from "@/utils/RoleUtils";
import { isActiveServie } from "@/utils/AccountSettingUtils";

@Component({
  components: {
    CoverageInfoCreateForm,
    CoverageInfoEditForm,
    CoverageInfoView,
  },
})
export default class CoverageInfoList extends Vue {
  name = "coverage-info";
  dateFrom = "";
  dateTo = "";
  items: Array<CoverageInfo> = [];
  coverageInfoService = new CoverageInfoService.CoverageInfoService();
  showForm = false;

  createDialog = false;
  viewDialog = false;
  editDialog = false;
  subscription;
  subscriptionUpdate;

  isOperate = true;

  async created() {
    try{
      const user = this.$store.getters.user;
      const role = decodeRoleJson(user.attributes["custom:role"] || undefined);
      this.isOperate = isAllow("coverageInfo", "operate", role.coverageInfo?.operate) && await isActiveServie("coverage");
      await this.search();
      this.setSubscription();
    }catch(e){
      console.error(e);
      this.$emit("loadEnd");
    }
  }

  async search() {
    this.dateFrom = this.$store.getters.selectCoverageDate;
    this.dateTo = this.$store.getters.selectCoverageDateTo;

    const dayStart = this.getStartDate();
    const dayEnd = this.getEndDate();

    const searchForm: SearchForm = {
      dayStart: dayStart,
      dayEnd: dayEnd,
    };
    this.items = await this.coverageInfoService.search(searchForm);
  }

  private getStartDate(){
    if(!this.dateFrom || this.dateFrom.length <= 0){
      return moment("1970-01-01").startOf("day").toISOString();
    }
    return moment(this.dateFrom).startOf("day").toISOString();
  }

  private getEndDate() {
    if((!this.dateFrom || this.dateFrom.length <= 0) && (!this.dateTo || this.dateTo.length <= 0)){
      return moment("2037-12-31").endOf("day").toISOString();
    }
    if(this.dateFrom && (!this.dateTo || this.dateTo.length <= 0)){
      return moment(this.dateFrom).endOf("day").toISOString();
    }
    return moment(this.dateTo).endOf("day").toISOString();
  }

  private createClose() {
    this.createDialog = false;
    setTimeout(() => {
      this.search();
    }, 1000);
  }

  private viewItem(item) {
    this.$store.commit("selectCoverageInfo", item.id);
    this.viewDialog = true;
  }

  private viewClose() {
    this.viewDialog = false;
  }

  private editItem(item) {
    this.$store.commit("selectCoverageInfo", item.id);
    this.editDialog = true;
  }

  private editClose() {
    this.editDialog = false;
    setTimeout(() => {
      this.search();
    }, 1000);
  }

  private async setSubscription() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === "selectCoverageDate" || mutation.type === "selectCoverageDateTo") {
        this.search();
      }
    });
  }
}
